export default "__VITE_ASSET__Cybs4tV4__"